import React, { useContext } from "react";
import { Route as RouterRoute, Redirect, matchPath } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const publicAlwaysAccessible = [
	"/login",
	"/signup",
	"/signup/:lang",
	"/pt/registre-se",
	"/cadastre-se",
	"/en/sign-up",
	"/sign-up",
	"/es/registrarse",
	"/registrarse",
	"/tr/kayit-ol",
	"/kayit-ol",
	"/ar/register",
	"/forgot-password",
	"/reset-password"
];

const isAlwaysAccessiblePublicRoute = (path) => (
	publicAlwaysAccessible.some((publicPath) => matchPath(path, { path: publicPath, exact: true }))
);

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
	const { isAuth, loading } = useContext(AuthContext);

	// Enquanto verifica autenticação, só mostra loading (sem redirect)
	if (loading) {
		return <BackdropLoading />;
	}

	if (!isAuth && isPrivate) {
		return <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />;
	}

	// Rotas públicas que devem ser acessíveis mesmo logado (ex: reset-password)
	if (isAuth && !isPrivate && !isAlwaysAccessiblePublicRoute(rest.path)) {
		return <Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
	}

	return <RouterRoute {...rest} component={Component} />;
};

export default Route;
